const BorrowerCard = ({
  icon,
  label,
  value,
  increment = "",
  type = "positive",
  padColor,
}) => {
  return (
    <div className="w-[310px] h-[154px] flex border border-[#D6D6D6] rounded-[15px]">
      <div
        style={{ backgroundColor: padColor }}
        className="w-[5px] h-[124px] my-auto mr-[10px]"
      ></div>
      <div className="h-full w-full p-[10px] flex flex-col justify-between">
        <div className="flex items-start gap-[5px]">
          <div className="bg-[#4B5D6712] rounded-[100%] h-[31px] w-[31px] flex items-center justify-center">
            {icon}
          </div>
          <p className="text-[14px] mt-[3px] font-normal">{label}</p>
        </div>
        <div className="flex items-center justify-center">
          <p className="font-bold text-[36px] text-[#222222]">{value}</p>
        </div>
        {increment.length > 0 ? (
          <div
            className={`h-[30px] w-[66px] ${
              type === "positive"
                ? "bg-[#DEFFF4] text-[#00A676]"
                : "bg-[#FFDEDE] text-[#000000]"
            } rounded-[30px] flex items-center justify-center`}
          >
            {increment}
          </div>
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
};

export default BorrowerCard;
